export default __webpack_public_path__ + "static/media/microphone.6d445368.svg";